import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { UserRole } from '../types'

interface AuthState {
  userId: string | null
  accessToken: string | null
  refreshToken: string | null
  userName: string | null
  userEmail: string | null
  userRole: UserRole | null
  isAuthenticated: boolean
  /** A sessão acabou sozinha (venceu ou foi revogada). Não é persistido: só serve para a tela de entrada avisar. */
  sessaoExpirada: boolean

  setAuth: (data: {
    userId: string
    accessToken: string
    refreshToken: string
    userName: string
    userEmail: string
    userRole: UserRole
  }) => void
  /** Guarda o par renovado sem mexer no resto da sessão. */
  atualizarTokens: (t: { accessToken: string; refreshToken: string }) => void
  logout: (opcoes?: { expirada?: boolean }) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      userId: null,
      accessToken: null,
      refreshToken: null,
      userName: null,
      userEmail: null,
      userRole: null,
      isAuthenticated: false,
      sessaoExpirada: false,

      setAuth: (data) =>
        set({
          ...data,
          isAuthenticated: true,
          sessaoExpirada: false,
        }),

      atualizarTokens: (t) => set(t),

      logout: (opcoes) =>
        set({
          sessaoExpirada: opcoes?.expirada === true,
          userId: null,
          accessToken: null,
          refreshToken: null,
          userName: null,
          userEmail: null,
          userRole: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'walleon-auth',
      partialize: (s) => ({
        userId: s.userId,
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
        userName: s.userName,
        userEmail: s.userEmail,
        userRole: s.userRole,
        isAuthenticated: s.isAuthenticated,
      }),
    },
  ),
)
